import { render } from "./3244068.vue?vue&type=template&id=791ef54c"
const script = {}

import exportComponent from "/data/jenkins/workspace/recopick-docs-static-prd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__